/**
 * Product Customizer v1.3
 * v1.3: fixed cart ordering — main product is ALWAYS added last (appears at top)
 *        file addon CDN URL is obtained by a throwaway add+remove of main product
 */
(function () {
  'use strict';

  var PHONE_MODELS = {
    'Apple': [
      'iPhone 13', 'iPhone 13 Plus', 'iPhone 13 Pro', 'iPhone 13 Pro Max',
      'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max',
      'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max',
      'iPhone 16', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max',
      'iPhone 17', 'iPhone 17 Pro', 'iPhone 17 Pro Max',
      'iPhone Air', 'iPhone 17e'
    ],
    'Samsung': [
      'S20 FE', 'Samsung S21 FE', 'Galaxy A23', 'Galaxy A35','Galaxy S23', 'Galaxy S23 Ultra', 'Galaxy S23 FE',
      'Galaxy S24', 'Galaxy S24+', 'Galaxy S24 Ultra', 'Galaxy S24 FE',
      'Galaxy S25', 'Galaxy S25+', 'Galaxy S25 Ultra',
      'Galaxy S26', 'Galaxy S26+', 'Galaxy S26 Ultra'
    ],
    'OnePlus': ['OnePlus 12R', 'OnePlus 13', 'OnePlus 13R', 'OnePlus 15R', 'OnePlus Nord 2T 5G ', 'OnePlus Nord 5', 'OnePlus Nord C2' ],
    'Google': [
      'Pixel 8',
      'Pixel 9', 'Pixel 9 Pro', 'Pixel 9 Pro XL', 'Pixel 9A',
      'Pixel 10', 'Pixel 10 Pro', 'Pixel 10 Pro XL', 'Pixel 10a'
    ],
    'Vivo': ['V20', 'V40 5G', 'V60 5G', 'V50', 'V70 5G', 'Vivo V70 Elite', 'VY31 Pro 5G', 'T4 Ultra', 'X100', 'X200', 'Y400', 'Y400 Pro'],
    'Xiaomi': ['Xiaomi 14', 'Xiaomi 14 Civi', 'Xiaomi 15', 'POCO F7', 'Xiaomi Note 10', 'Xiaomi 13C'],
    'Realme': ['GT 7', 'Realme 16 Pro+', 'Realme 14 Pro'],
    'iQOO': ['iQOO Neo 10','iQOO Neo 10R','iQOO Neo 10R 5G', 'iQOO 13'],
    'Nothing': ['Nothing Phone 3', 'Nothing Phone 4a', 'Nothing 2A'],
    'Motorola': ['Edge 60 Pro','Edge 70 Fusion'],
    'Oppo': ['Oppo A60', 'Oppo A6 5G', 'Oppo F25 Pro 5G', 'Oppo Reno 11 Pro 5G', 'Oppo Reno 15F 5G','Oppo K13 5G', 'Oppo A5X', 'Oppo F31']
  };

  function getProductForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function ensureHidden(form, name) {
    var n = 'properties[' + name + ']';
    var el = form.querySelector('input[name="' + n + '"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = n; form.appendChild(el); }
    return el;
  }
  function sync(form, name, val) { ensureHidden(form, name).value = val; }
  function unsync(form, name) { var el = form.querySelector('input[name="properties[' + name + ']"]'); if (el) el.remove(); }
  function showErr(c, m) { var e = c.querySelector('.pcust-error'); if (!e) { e = document.createElement('div'); e.className = 'pcust-error'; c.appendChild(e); } e.textContent = m; e.style.display = 'block'; }
  function clearErr(c) { var e = c.querySelector('.pcust-error'); if (e) e.style.display = 'none'; }
  function resetBtn(pf) { var b = pf ? pf.querySelector('[type="submit"]') : null; if (b) { b.classList.remove('loading'); b.removeAttribute('aria-disabled'); } }

  function initCustomizer(container) {
    var config;
    try { config = JSON.parse(container.getAttribute('data-customizer-config')); } catch(e) { return; }
    var productForm = getProductForm(); if (!productForm) return;
    var productFormEl = productForm.closest('product-form');
    var brandSelect = container.querySelector('[data-field="Brand"]');
    var modelSelect = container.querySelector('[data-field="Model"]');

    if (brandSelect && modelSelect) {
      brandSelect.addEventListener('change', function () {
        var brand = this.value; sync(productForm, 'Brand', brand);
        modelSelect.innerHTML = '<option value="">Select Model</option>';
        modelSelect.disabled = true; modelSelect.classList.add('pcust-disabled');
        sync(productForm, 'Model', '');
        if (brand && PHONE_MODELS[brand]) {
          PHONE_MODELS[brand].forEach(function (m) { var o = document.createElement('option'); o.value = m; o.textContent = m; modelSelect.appendChild(o); });
          modelSelect.disabled = false; modelSelect.classList.remove('pcust-disabled');
        }
      });
      modelSelect.addEventListener('change', function () { sync(productForm, 'Model', this.value); });
    }

    var addonConfigs = config.addons || [];
    addonConfigs.forEach(function (addon) {
      var toggle = container.querySelector('[data-addon-toggle="' + addon.key + '"]');
      var fw = container.querySelector('[data-addon-field="' + addon.key + '"]');
      if (!toggle || !fw) return;
      fw.style.display = 'none';
      toggle.addEventListener('change', function () {
        if (this.checked) {
          fw.style.display = 'block';
          var ti = fw.querySelector('input[type="text"]'); if (ti) sync(productForm, addon.key, ti.value);
        } else {
          fw.style.display = 'none'; unsync(productForm, addon.key);
          var ti = fw.querySelector('input[type="text"]'); if (ti) ti.value = '';
          var fi = fw.querySelector('input[type="file"]'); if (fi) { fi.value = ''; var ns = fw.querySelector('.pcust-file-name'); if (ns) ns.textContent = ''; }
        }
      });
      var ti = fw.querySelector('input[type="text"]');
      if (ti) ti.addEventListener('input', function () { sync(productForm, addon.key, this.value); });
    });

    productForm.addEventListener('submit', function (evt) {
      clearErr(container);
      var req = (config.fields || []).filter(function (f) { return f.required; });
      for (var i = 0; i < req.length; i++) {
        var sel = container.querySelector('[data-field="' + req[i].key + '"]');
        if (sel && !sel.value) { evt.preventDefault(); evt.stopImmediatePropagation(); showErr(container, 'Please select your ' + req[i].key + ' before adding to cart.'); sel.focus(); resetBtn(productFormEl); return; }
      }
      for (var j = 0; j < addonConfigs.length; j++) {
        var a = addonConfigs[j], t = container.querySelector('[data-addon-toggle="' + a.key + '"]');
        if (t && t.checked) {
          var fw = container.querySelector('[data-addon-field="' + a.key + '"]');
          if (a.type === 'text') { var ti = fw ? fw.querySelector('input[type="text"]') : null; if (ti && !ti.value.trim()) { evt.preventDefault(); evt.stopImmediatePropagation(); showErr(container, 'Please enter your ' + a.key + ' or uncheck the option.'); ti.focus(); resetBtn(productFormEl); return; } }
          if (a.type === 'file') { var fi = fw ? fw.querySelector('input[type="file"]') : null; if (fi && fi.files.length === 0) { evt.preventDefault(); evt.stopImmediatePropagation(); showErr(container, 'Please upload your ' + a.key + ' or uncheck the option.'); resetBtn(productFormEl); return; } }
        }
      }

      var activeAddons = [], hasFile = false;
      addonConfigs.forEach(function (a) {
        var t = container.querySelector('[data-addon-toggle="' + a.key + '"]');
        if (t && t.checked && a.variantId) {
          var props = {};
          var bv = brandSelect ? brandSelect.value : '', mv = modelSelect ? modelSelect.value : '';
          if (bv) props['For'] = bv + (mv ? ' ' + mv : '');
          if (a.type === 'text') { var fw = container.querySelector('[data-addon-field="' + a.key + '"]'); var ti = fw ? fw.querySelector('input[type="text"]') : null; if (ti && ti.value.trim()) props[a.key] = ti.value.trim(); }
          if (a.type === 'file') { hasFile = true; props['_needs_cdn'] = true; }
          activeAddons.push({ variantId: a.variantId, properties: props, key: a.key });
        }
      });

      if (activeAddons.length === 0) return;

      evt.preventDefault(); evt.stopImmediatePropagation();
      var submitBtn = productFormEl ? productFormEl.querySelector('[type="submit"]') : null;
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        if (hasFile) {
          // Theme hides .btn-label and shows spinner on .loading
          // We override: hide spinner, show label with upload text
          var btnLabel = submitBtn.querySelector('.btn-label');
          var btnSpinner = submitBtn.querySelector('.icon-load');
          if (btnLabel) {
            btnLabel.setAttribute('data-original-text', btnLabel.textContent);
            btnLabel.textContent = 'Uploading your photo\u2026';
            btnLabel.style.opacity = '1';
          }
          if (btnSpinner) btnSpinner.style.opacity = '0';
        }
      }

      doMultiAdd(productForm, activeAddons, hasFile, container, config)
        .catch(function (err) { console.error('[PC]', err); showErr(container, 'Something went wrong. Please try again.'); })
        .finally(function () {
          resetBtn(productFormEl);
          if (submitBtn) {
            var btnLabel = submitBtn.querySelector('.btn-label');
            var btnSpinner = submitBtn.querySelector('.icon-load');
            if (btnLabel && btnLabel.getAttribute('data-original-text')) {
              btnLabel.textContent = btnLabel.getAttribute('data-original-text');
              btnLabel.removeAttribute('data-original-text');
              btnLabel.style.opacity = '';
            }
            if (btnSpinner) btnSpinner.style.opacity = '';
          }
        });
    }, true);
  }

  /**
   * Cart add strategy (v1.3):
   *
   * NO file addon:
   *   1. Add all add-ons (JSON)
   *   2. Add main product (FormData) → lands on top
   *
   * WITH file addon:
   *   1. Temporarily add main product (FormData with file) to get CDN URL
   *   2. Read CDN URL from response
   *   3. Remove the temp main product from cart
   *   4. Add ALL add-ons (including file one with CDN URL) via JSON
   *   5. Re-add main product (FormData with file) → lands on top
   */
  function doMultiAdd(productForm, activeAddons, hasFile, container, config) {
    var nonFileAddons = activeAddons.filter(function (a) { return !a.properties._needs_cdn; });
    var fileAddons = activeAddons.filter(function (a) { return a.properties._needs_cdn; });
    nonFileAddons.forEach(function (a) { delete a.properties._needs_cdn; });

    function buildMainFormData() {
      var fd = new FormData(productForm);
      if (hasFile) {
        var fileConfigs = (config.addons || []).filter(function (a) { return a.type === 'file'; });
        fileConfigs.forEach(function (a) {
          var t = container.querySelector('[data-addon-toggle="' + a.key + '"]');
          if (t && t.checked) {
            var fw = container.querySelector('[data-addon-field="' + a.key + '"]');
            var fi = fw ? fw.querySelector('input[type="file"]') : null;
            if (fi && fi.files[0]) fd.append('properties[' + a.key + ']', fi.files[0]);
          }
        });
      }
      return fd;
    }

    function addMainProduct(fd) {
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      return fetch(window.routes.cart_add_url, {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
      }).then(function (r) { return r.json(); }).then(function (resp) {
        if (resp.status) throw new Error(resp.description || 'Could not add to cart');
        return resp;
      });
    }

    function addJsonItems(items) {
      if (items.length === 0) return Promise.resolve(null);
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); });
    }

    function removeCartItem(lineItemKey) {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineItemKey, quantity: 0 })
      }).then(function (r) { return r.json(); });
    }

    var chain;

    if (!hasFile) {
      // Simple path: add-ons first, then main product
      var addonItems = nonFileAddons.map(function (a) { return { id: parseInt(a.variantId, 10), quantity: 1, properties: a.properties }; });
      chain = addJsonItems(addonItems).then(function () {
        return addMainProduct(buildMainFormData());
      });
    } else {
      // Complex path: temp add main → get CDN → remove → add all addons → re-add main
      chain = addMainProduct(buildMainFormData()).then(function (tempResp) {
        var cdnUrl = '';
        if (tempResp.properties) {
          fileAddons.forEach(function (a) { if (tempResp.properties[a.key]) cdnUrl = tempResp.properties[a.key]; });
        }
        var lineKey = tempResp.key;

        // Remove the temp main product
        return removeCartItem(lineKey).then(function () {
          // Prepare all addon items (both text and file)
          fileAddons.forEach(function (a) { delete a.properties._needs_cdn; if (cdnUrl) a.properties[a.key] = cdnUrl; });
          var allAddonItems = activeAddons.map(function (a) { return { id: parseInt(a.variantId, 10), quantity: 1, properties: a.properties }; });

          // Add all add-ons
          return addJsonItems(allAddonItems);
        }).then(function () {
          // Re-add main product (this time it's the newest = top of cart)
          return addMainProduct(buildMainFormData());
        });
      });
    }

    return chain.then(function () {
      return fetch('/cart.json').then(function (r) { return r.json(); }).then(function (cartData) {
        if (cartData.item_count != undefined) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            if (el.classList.contains('cart-count-drawer')) el.innerHTML = '(' + cartData.item_count + ')';
            else el.innerHTML = cartData.item_count > 100 ? '~' : cartData.item_count;
          });
          if (document.querySelector('header-total-price')) document.querySelector('header-total-price').updateTotal(cartData);
          var fs = document.querySelector('free-ship-progress-bar'); if (fs) fs.init(cartData.items_subtotal_price);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-customizer', cartData: cartData });
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
          return fetch(window.location.pathname + '?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (sections) {
            cart.getSectionsToRender().forEach(function (s) {
              var el = document.getElementById(s.id);
              if (el && sections[s.id]) { var h = new DOMParser().parseFromString(sections[s.id], 'text/html'); var mc = h.querySelector('#minicart-form'); if (mc) el.innerHTML = mc.innerHTML; }
            });
            cart.cartAction(); if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.open();
          });
        } else { window.location = window.routes.cart_url; }
      });
    });
  }

function init() { document.querySelectorAll('[data-customizer-config]').forEach(initCustomizer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();